import React from "react";
import "./StudentHomePage.css";
import Tolbar from "../Tolbar/Tolbar";
import Dashbord from "../Dashbord/Dashbord";
import Typography from "../../Typography/Typography";
const Studenthomepage = () => {
  return (
    <div>
      <Tolbar />
      <Typography />
      <Dashbord />
    </div>
  );
};

export default Studenthomepage;
